import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";
class PackService {
  addNewPack(model) {
    return api.post(UtilsUrl.packURL() + "/addPack", model);
  }
  addPackComposition(model) {
    return api.post(UtilsUrl.packURL() + "/addPackComposition", model);
  }
  allPack(idUser, isActive) {
    return api.get(UtilsUrl.packURL() + "/allPack/" + idUser + "/" + isActive);
  }
  addNewPackRegroupement(model) {
    return api.post(UtilsUrl.packURL() + "/addPackMarketingRegroupement", model);
  }
  verifiePackExistanceByReference(idUser, refPack) {
    return api.get(
      UtilsUrl.packURL() +
      "/verifiePackExistanceByReference/" +
      idUser +
      "/" +
      refPack
    );
  }
  addPackByRefProductBarCode(idUser, idWarehouse, barcodeProduct, namePack) {
    return api.get(
      UtilsUrl.packURL() +
      "/addPackByRefProductBarCode/" +
      idUser +
      "/" +
      idWarehouse +
      "/" +
      barcodeProduct +
      "/" +
      namePack
    );
  }
  packDetails(id) {
    return api.get(UtilsUrl.packURL() + "/getPackDetails/" + id);
  }
  DeletePack(idUser, idPack) {
    return api.put(UtilsUrl.packURL() + "/deletePack/" + idUser + "/" + idPack);
  }
}
export default new PackService();
